import { render, staticRenderFns } from "./modalAddPushNotification.vue?vue&type=template&id=e797cde4&"
import script from "./modalAddPushNotification.vue?vue&type=script&lang=js&"
export * from "./modalAddPushNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports